import React from 'react';
import usePolygonsStore from '../../store/usePolygonsStore';
import usePolygonEventStore from '_viewport-maps/src/store/usePolygonEventStore';
import MapShape from './MapShape';
function MapShapes({ isMobile = false }) {
    const { polygons } = usePolygonsStore(["polygons"]);
    const { hoveredLotId, clickedLotId } = usePolygonEventStore(["hoveredLotId", "clickedLotId"]);
    return (React.createElement(React.Fragment, null, polygons.map((polygon, index) => (React.createElement(MapShape, { isMobile: isMobile, polygon: polygon, index: index, key: index, isHovered: hoveredLotId == polygon.Properties.Id, isClicked: clickedLotId === polygon.Properties.Id })))));
}
export default MapShapes;
